/**
 * @typedef {Object} RoleOption
 * @property {string} value - The internal value identifier for the role
 * @property {string} label - The human-readable display label for the role
 */

/**
 * Predefined role options for the GEAO (GEICO External Agent Onboarding) system.
 * 
 * This constant provides a frozen array of role options that can be selected
 * during the agency onboarding process. Each option contains a value for
 * internal processing and a label for display purposes.
 * 
 * @type {ReadonlyArray<RoleOption>}
 * @constant
 * @default
 * 
 * @example
 * // Usage in a select component
 * import RoleOptions from './RoleOptions';
 * 
 * const SelectRole = () => (
 *   <select>
 *     {RoleOptions.map(option => (
 *       <option key={option.value} value={option.value}>
 *         {option.label}
 *       </option>
 *     ))}
 *   </select>
 * );
 * 
 * @example
 * // Finding a specific role option
 * const producerRole = RoleOptions.find(role => role.value === 'producer');
 * console.log(producerRole.label); // "Producer"
 */
export default Object.freeze([
    { value: "principal", label: "Principal/Owner" },
    { value: "producer", label: "Producer" },
    { value: "csr", label: "Customer Service Rep" },
    { value: "branch-manager", label: "Branch Manager" },
    { value: "other-employee", label: "Other Employee" }
]);